import { defineStore } from "pinia";

const invoices = [
  {
    id: 1,
    invoiceNo: "INV-2026-0001",
    billingMonth: "มีนาคม 2026",
    unitCode: "A-101",
    residentName: "สมชาย ใจดี",
    building: "อาคาร A",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 1800,
    penalty: 0,
    totalAmount: 1800,
    paidAmount: 1800,
    status: "paid",
    note: "ชำระครบภายในกำหนด",
  },
  {
    id: 2,
    invoiceNo: "INV-2026-0002",
    billingMonth: "มีนาคม 2026",
    unitCode: "A-102",
    residentName: "สุดา รุ่งเรือง",
    building: "อาคาร A",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 1800,
    penalty: 0,
    totalAmount: 1800,
    paidAmount: 900,
    status: "partial",
    note: "อยู่ระหว่างผ่อนชำระ",
  },
  {
    id: 3,
    invoiceNo: "INV-2026-0003",
    billingMonth: "กุมภาพันธ์ 2026",
    unitCode: "B-203",
    residentName: "นที วรากร",
    building: "อาคาร B",
    issueDate: "2026-02-01",
    dueDate: "2026-02-28",
    amount: 2500,
    penalty: 700,
    totalAmount: 3200,
    paidAmount: 0,
    status: "overdue",
    note: "เกินกำหนดชำระและมีค่าปรับ",
  },
  {
    id: 4,
    invoiceNo: "INV-2026-0004",
    billingMonth: "มีนาคม 2026",
    unitCode: "C-305",
    residentName: "อรทัย พงศ์พันธ์",
    building: "อาคาร C",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 2200,
    penalty: 0,
    totalAmount: 2200,
    paidAmount: 2200,
    status: "paid",
    note: "ออกใบเสร็จเรียบร้อย",
  },
  {
    id: 5,
    invoiceNo: "INV-2026-0005",
    billingMonth: "มีนาคม 2026",
    unitCode: "D-110",
    residentName: "ปกรณ์ ศิริชัย",
    building: "อาคาร D",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 2800,
    penalty: 0,
    totalAmount: 2800,
    paidAmount: 2800,
    status: "paid",
    note: "ชำระผ่านโอนธนาคาร",
  },
  {
    id: 6,
    invoiceNo: "INV-2026-0006",
    billingMonth: "มีนาคม 2026",
    unitCode: "E-402",
    residentName: "จิราพร บุญมี",
    building: "อาคาร E",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 1900,
    penalty: 600,
    totalAmount: 2500,
    paidAmount: 0,
    status: "overdue",
    note: "ติดตามค้างชำระรอบแรกแล้ว",
  },
  {
    id: 7,
    invoiceNo: "INV-2026-0007",
    billingMonth: "มีนาคม 2026",
    unitCode: "G-109",
    residentName: "พรทิพย์ สกุลดี",
    building: "อาคาร G",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 2600,
    penalty: 0,
    totalAmount: 2600,
    paidAmount: 1400,
    status: "partial",
    note: "รับชำระบางส่วนผ่าน QR Payment",
  },
  {
    id: 8,
    invoiceNo: "INV-2026-0008",
    billingMonth: "มีนาคม 2026",
    unitCode: "H-501",
    residentName: "ชัยวัฒน์ ทองสุข",
    building: "อาคาร H",
    issueDate: "2026-03-01",
    dueDate: "2026-03-31",
    amount: 3200,
    penalty: 1800,
    totalAmount: 5000,
    paidAmount: 0,
    status: "overdue",
    note: "ยอดค้างสะสมเกิน 60 วัน",
  },
  {
    id: 9,
    invoiceNo: "INV-2026-0009",
    billingMonth: "เมษายน 2026",
    unitCode: "J-120",
    residentName: "กิตติภพ สุขใจ",
    building: "อาคาร J",
    issueDate: "2026-04-01",
    dueDate: "2026-04-30",
    amount: 2850,
    penalty: 0,
    totalAmount: 2850,
    paidAmount: 0,
    status: "pending",
    note: "รอการชำระในรอบปัจจุบัน",
  },
  {
    id: 10,
    invoiceNo: "INV-2026-0010",
    billingMonth: "เมษายน 2026",
    unitCode: "F-208",
    residentName: "วสันต์ เกียรติยศ",
    building: "อาคาร F",
    issueDate: "2026-04-01",
    dueDate: "2026-04-30",
    amount: 4100,
    penalty: 0,
    totalAmount: 4100,
    paidAmount: 0,
    status: "pending",
    note: "ออกบิลใหม่ประจำเดือน",
  },
];

const invoiceLineItems = {
  1: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 1800,
      amount: 1800,
    },
  ],
  2: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 1800,
      amount: 1800,
    },
  ],
  3: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน กุมภาพันธ์ 2026",
      qty: 1,
      unitPrice: 2500,
      amount: 2500,
    },
    {
      id: 2,
      description: "ค่าปรับล่าช้า",
      qty: 1,
      unitPrice: 700,
      amount: 700,
    },
  ],
  4: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 2200,
      amount: 2200,
    },
  ],
  5: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 2800,
      amount: 2800,
    },
  ],
  6: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 1900,
      amount: 1900,
    },
    {
      id: 2,
      description: "ค่าปรับล่าช้า",
      qty: 1,
      unitPrice: 600,
      amount: 600,
    },
  ],
  7: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 2600,
      amount: 2600,
    },
  ],
  8: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน มีนาคม 2026",
      qty: 1,
      unitPrice: 3200,
      amount: 3200,
    },
    {
      id: 2,
      description: "ค่าปรับสะสม",
      qty: 1,
      unitPrice: 1800,
      amount: 1800,
    },
  ],
  9: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน เมษายน 2026",
      qty: 1,
      unitPrice: 2850,
      amount: 2850,
    },
  ],
  10: [
    {
      id: 1,
      description: "ค่าส่วนกลางประจำเดือน เมษายน 2026",
      qty: 1,
      unitPrice: 4100,
      amount: 4100,
    },
  ],
};

const paymentHistory = {
  1: [
    {
      id: "PAY-2026-0011",
      date: "2026-03-29",
      amount: 1800,
      method: "โอนธนาคาร",
      receiptNo: "RC-2026-0011",
      recordedBy: "Finance 01",
    },
  ],
  2: [
    {
      id: "PAY-2026-0014",
      date: "2026-03-18",
      amount: 900,
      method: "เงินสด",
      receiptNo: "RC-2026-0014",
      recordedBy: "Finance 02",
    },
  ],
  4: [
    {
      id: "PAY-2026-0021",
      date: "2026-03-27",
      amount: 2200,
      method: "QR Payment",
      receiptNo: "RC-2026-0021",
      recordedBy: "Finance 01",
    },
  ],
  5: [
    {
      id: "PAY-2026-0022",
      date: "2026-03-30",
      amount: 2800,
      method: "โอนธนาคาร",
      receiptNo: "RC-2026-0022",
      recordedBy: "Finance 01",
    },
  ],
  7: [
    {
      id: "PAY-2026-0018",
      date: "2026-03-12",
      amount: 1400,
      method: "QR Payment",
      receiptNo: "RC-2026-0018",
      recordedBy: "Finance 02",
    },
  ],
};

export const useInvoiceStore = defineStore("invoice", {
  state: () => ({
    filters: {
      search: "",
      status: "",
      billingMonth: "",
    },
    invoices,
    invoiceLineItems,
    paymentHistory,
  }),

  getters: {
    filteredInvoices: (state) => {
      const keyword = state.filters.search.trim().toLowerCase();

      return state.invoices.filter((invoice) => {
        const searchable = [
          invoice.invoiceNo,
          invoice.billingMonth,
          invoice.unitCode,
          invoice.residentName,
          invoice.building,
        ]
          .join(" ")
          .toLowerCase();

        const matchesSearch = !keyword || searchable.includes(keyword);
        const matchesStatus =
          !state.filters.status || invoice.status === state.filters.status;
        const matchesBillingMonth =
          !state.filters.billingMonth ||
          invoice.billingMonth === state.filters.billingMonth;

        return matchesSearch && matchesStatus && matchesBillingMonth;
      });
    },

    totalInvoices: (state) => state.invoices.length,
    paidInvoices: (state) =>
      state.invoices.filter((item) => item.status === "paid").length,
    overdueInvoices: (state) =>
      state.invoices.filter((item) => item.status === "overdue").length,
    pendingInvoices: (state) =>
      state.invoices.filter((item) => item.status === "pending").length,
    totalRevenue: (state) =>
      state.invoices.reduce((sum, item) => sum + item.paidAmount, 0),
    totalOutstanding: (state) =>
      state.invoices.reduce(
        (sum, item) => sum + (item.totalAmount - item.paidAmount),
        0,
      ),

    statusOptions: () => [
      { label: "ทั้งหมด", value: "" },
      { label: "รอชำระ", value: "pending" },
      { label: "ชำระบางส่วน", value: "partial" },
      { label: "ชำระแล้ว", value: "paid" },
      { label: "ค้างชำระ", value: "overdue" },
    ],

    billingMonthOptions: (state) => {
      const months = [
        ...new Set(state.invoices.map((item) => item.billingMonth)),
      ];
      return [
        { label: "ทั้งหมด", value: "" },
        ...months.map((month) => ({ label: month, value: month })),
      ];
    },

    getInvoiceById: (state) => (id) =>
      state.invoices.find((item) => item.id === Number(id)) || null,
    getLineItemsByInvoiceId: (state) => (id) =>
      state.invoiceLineItems[Number(id)] || [],
    getPaymentsByInvoiceId: (state) => (id) =>
      state.paymentHistory[Number(id)] || [],
  },

  actions: {
    setSearch(value) {
      this.filters.search = value;
    },
    setStatus(value) {
      this.filters.status = value;
    },
    setBillingMonth(value) {
      this.filters.billingMonth = value;
    },
    resetFilters() {
      this.filters.search = "";
      this.filters.status = "";
      this.filters.billingMonth = "";
    },
    addInvoice(payload) {
      const nextId = this.invoices.length
        ? Math.max(...this.invoices.map((i) => i.id)) + 1
        : 1;

      const running = String(nextId).padStart(4, "0");
      const year = new Date().getFullYear();

      const totalAmount =
        Number(payload.amount || 0) + Number(payload.penalty || 0);

      this.invoices.unshift({
        id: nextId,
        invoiceNo: `INV-${year}-${running}`,
        billingMonth: payload.billingMonth,
        unitCode: payload.unitCode,
        residentName: payload.residentName,
        building: payload.building,
        issueDate: payload.issueDate,
        dueDate: payload.dueDate,
        amount: Number(payload.amount) || 0,
        penalty: Number(payload.penalty) || 0,
        totalAmount,
        paidAmount: 0,
        status: "pending",
        note: payload.note || "",
      });

      // เพิ่ม line items อัตโนมัติ
      const items = [
        {
          id: 1,
          description: `ค่าส่วนกลางประจำเดือน ${payload.billingMonth}`,
          qty: 1,
          unitPrice: Number(payload.amount),
          amount: Number(payload.amount),
        },
      ];
      if (Number(payload.penalty) > 0) {
        items.push({
          id: 2,
          description: "ค่าปรับล่าช้า",
          qty: 1,
          unitPrice: Number(payload.penalty),
          amount: Number(payload.penalty),
        });
      }
      this.invoiceLineItems[nextId] = items;
    },
    updateInvoice(payload) {
      const index = this.invoices.findIndex((i) => i.id === payload.id);
      if (index === -1) return;
      const totalAmount =
        Number(payload.amount || 0) + Number(payload.penalty || 0);
      this.invoices[index] = {
        ...this.invoices[index],
        billingMonth: payload.billingMonth,
        unitCode: payload.unitCode,
        residentName: payload.residentName,
        building: payload.building,
        issueDate: payload.issueDate,
        dueDate: payload.dueDate,
        amount: Number(payload.amount) || 0,
        penalty: Number(payload.penalty) || 0,
        totalAmount,
        note: payload.note || "",
      };
    },
  },
});
